export default __webpack_public_path__ + "static/media/low_price.799e26e5.svg";